import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { DashboardInterceptor } from '@core';
import { AuthGuardService } from '@core/services/guards/auth-guard.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCoffee, fas } from '@fortawesome/free-solid-svg-icons';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FormlyModule } from '@ngx-formly/core';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CookieService } from 'ngx-cookie-service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { CoreModule } from './core/core.module';
import { AccountViewGuard } from './features/account-view/account-view.guard';
import { FeaturesModule } from './features/features.module';
import { SharedModule } from './shared/shared.module';
import { ThemeModule } from './theme/theme.module';
import { JwtModule } from "@auth0/angular-jwt";
import { FormsModule } from '@angular/forms';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    return super.parse(url);
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,    
    EffectsModule.forRoot([]),
    ExcelModule,
    FeaturesModule,
    FontAwesomeModule,
    FormlyModule.forRoot(),
    GridModule,
    HttpClientModule,
    NgxDatatableModule,
    NgxMatDatetimePickerModule,
    NgxMaterialTimepickerModule,
    NgxMatMomentModule,
    NgxMatTimepickerModule,    
    PdfViewerModule,
    SharedModule,
    FormsModule,
    StoreModule.forRoot({}),
    ThemeModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    ToastrModule.forRoot({
      timeOut: 10000,
      preventDuplicates: true,
      closeButton: true,
      positionClass: 'toast-top-right',
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DashboardInterceptor,
      multi: true,
    },
    AppConfig,
    AccountViewGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
    AuthGuardService,
    CookieService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
    library.addIcons(faCoffee);
  }
}

export function tokenGetter() {
  return localStorage.getItem("accesstoken");
}
